export default "<app-home [tradinSystemName]=\"tradinSytem.label\" [buttons]=\"buttons\">\n  <app-stock-entry></app-stock-entry>\n</app-home>\n";